import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { LoadingService } from '../../../../util/loader.service';
import { ImportarClienteService } from '../importar-cliente.service';

const swal = require('sweetalert');

@Component({
  selector: 'app-modal-importa-cliente',
  templateUrl: './modal-importa-cliente.component.html',
  styleUrls: ['./modal-importa-cliente.component.scss']
})
export class ModalImportaClienteComponent implements OnInit {
  public onClose: Subject<any>;
  valForm: FormGroup;
  anexo64: any = null;
  constructor(
    private _bsModalRef: BsModalRef,
    public loader: LoadingService,
    private route: ActivatedRoute,
    fb: FormBuilder,
    public service: ImportarClienteService) {

    this.valForm = fb.group({
      'anexo': [null, [Validators.required]],
    });
  }

  onFileChange(event) {
    const reader = new FileReader();
    this.anexo64 = null;
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      const theFile = event.target.files[0];
      const filename = theFile.name;
      const index = filename.lastIndexOf(".");
      if (theFile.size > 10000000) {
        swal('Atenção', 'O aquivo não pode ser maior que 10MB', 'warning');
      } else {
        const strsubstring = filename.substring(index, filename.length);
        if (strsubstring === '.csv') {
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.anexo64 = reader.result;
          };

        } else {
          this.valForm.controls['anexo'].reset();
          swal('Atenção', 'Selecione um arquivo do tipo CSV', 'warning');
        }
      }
    }
  }

  importar() {
    this.loader.show('body')
    this.service.importFile(this.anexo64).subscribe(itens => {
      this.loader.hide('body');
      if (itens != null && itens.id_importacao_cliente > 0) {
        swal('Atenção', 'Arquivo enviado com sucesso! Agora vamos processar as Informações  e importar os dados.', 'success');
        this.onOk();
      }

    });
  }

  ngOnInit() {
    this.onClose = new Subject();


  }

  public onCancel(): void {
    const output = {
      reload: false
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }

  public onOk(): void {
    const output = {
      reload: true
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }



}
